import React from 'react';

import { ReactQueryDevtools } from 'react-query/devtools';

import { useToggle } from '@alluradirect/react';
import { Divider } from '@mui/material';
import { Page } from 'components/layout/Page/Page';
import { FeaturesBenefits } from 'components/views/pages/list/components/FeaturesBenefits';
import { FullBarGetStarted } from 'components/views/pages/list/components/FullBarGetStarted';
import { HeroHeader } from 'components/views/pages/bigwhitepass/components/HeroHeader';
import { TopNavLinks } from 'components/views/pages/bigwhitepass/components/TopNavLinks';
import UserTestimonials from 'components/views/pages/list/components/UserTestimonials';
import { ContentWrapper } from 'components/views/pages/list/components/styles';
import { useResortsQuery } from 'hooks/api/location/useResortsQuery';
import { Footer } from 'scenes/dashboard/components/LeftNavContent/styles';
import { PageHeaderHelpDialog } from 'components/layout/Page/components/PageHeaderHelpDialog';
import { ListFooterBar } from './components/ListFooterBar';
import { FullInformationBar } from '../list/components/FullInformationBar';
import { ClaimPerkSteps } from './components/ClaimPerkSteps';
import { WhatAllura } from './components/WhatAllura';
import { ClaimPerkModal } from './components/ClaimPerkModal';
import { userNextRouteTransitions } from 'hooks/useNextRouteTransitions';
import { listProperty } from 'config/imageUrls';

export const BigWhitePass = () => {
  // Load the Resorts when the page is rendered so that the modal data is loaded.
  // In the next phase of this project, we will be able to prime React Query in production
  // by loading these variables on the server side and injecting them into RQ.
  useResortsQuery();
  const helpToggle = useToggle();
  const claimToggle = useToggle();
  const { navigateToListPage } = userNextRouteTransitions();

  return (
    <Page hasHeader={false} appSEOProps={{ description: 'Get deals on alluraDirect if you are a Big White passholder.', title: 'Big White Season\'s Pass Offers', image: listProperty }}>
      <ContentWrapper>

        <TopNavLinks />
        <HeroHeader openModal={claimToggle.open} />

        <FullInformationBar title="How it works" />

        <ClaimPerkSteps openModal={claimToggle.open} />

        <FullInformationBar title="What is alluraDirect" />

        <WhatAllura />

        <FullInformationBar title="I'm a property Host" />

        <FeaturesBenefits />

        <FullBarGetStarted onClick={navigateToListPage} />

        <UserTestimonials />
        <Divider />
        <ListFooterBar />

        <Footer />
      </ContentWrapper>

      {helpToggle.isOpen ? <PageHeaderHelpDialog isOpen={helpToggle.isOpen} close={helpToggle.close} /> : null}
      {claimToggle.isOpen ? <ClaimPerkModal isOpen={claimToggle.isOpen} closeModal={claimToggle.close} /> : null}
      <ReactQueryDevtools initialIsOpen={false} />
    </Page>
  );
};
